/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CommonCustomPercentileFields } from './CommonCustomPercentileFields';

export type CustomPercentile = (CommonCustomPercentileFields & {
    id: number;
    companyId?: number;
    columnPostfix: CustomPercentile.columnPostfix;
});

export namespace CustomPercentile {

    export enum columnPostfix {
        CP1 = 'CP1',
    }


}

